import * as RadixDialog from '@radix-ui/react-dialog';
import { memo } from 'react';

import { ActionSheetContent, type ActionSheetContentProps } from './ActionSheetContent';
import { ActionSheetOverlay } from './ActionSheetOverlay';

export type ActionSheetProps = Omit<ActionSheetContentProps, 'title'> & {
  onClose: () => void;
};

export const ActionSheet = memo(({ onClose, ...restOfProps }: ActionSheetProps) => {
  return (
    <RadixDialog.Root onOpenChange={onClose} open>
      <RadixDialog.Portal>
        <ActionSheetOverlay />
        <ActionSheetContent onClose={onClose} {...restOfProps} />
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
});

ActionSheet.displayName = 'ActionSheet';
